import BottomMenu from './BottomMenu';
import './PodcastLoadingView.css';

const PodcastLoadingView = () => (
    <div className='container appScreen'>
        <div className='hasBottomMenu'>
            <section
                className='podcastLoadingHeader'
                role='status'
                aria-live='polite'
                aria-label='Loading podcast'
            >
                <div className='entityHeaderCard entityHeaderCardPodcast' aria-hidden='true'>
                    <div className='podcastHeaderArtwork'>
                        <div className='largeSourceImage podcastArtwork loading podcastLoadingArtwork' />
                    </div>

                    <div className='entityHeaderText'>
                        <div className='podcastNameLarge'>
                            <div className='loading podcastLoadingTitle' />
                        </div>
                        <div className='podcastSummary podcastHeaderSummaryButton podcastLoadingSummary'>
                            {[1, 0.94, 1, 0.68].map((width, index) => (
                                <div
                                    key={index}
                                    className='loading podcastLoadingSummaryLine'
                                    style={{ width: `${width * 100}%` }}
                                />
                            ))}
                        </div>
                    </div>

                    <div className='entityHeaderSubscribe'>
                        <div className='loading podcastLoadingFollow' />
                    </div>
                </div>
            </section>
            <BottomMenu />
        </div>
    </div>
);

export default PodcastLoadingView;
